import React from "react";
import { Composition } from "remotion";
import { ClipSchema } from "@hudhud/core";
import { Reel } from "./Reel.js";
import { FPS, HEIGHT, REEL_ID, WIDTH, type ReelProps } from "./types.js";
import { reelDurationFrames } from "./timing.js";

const defaultClip = ClipSchema.parse({
  id: "preview", videoId: "preview", sourceStartMs: 0, sourceEndMs: 5000, segments: [{ inMs: 0, outMs: 5000 }],
  hook: { text: "Preview" },
});

export const defaultProps: ReelProps = { clip: defaultClip, mediaUrl: "", mediaStartMs: 0, logoUrl: "", fontsBaseUrl: "" };

export const Root: React.FC = () => (
  <Composition
    id={REEL_ID}
    component={Reel as any}
    width={WIDTH}
    height={HEIGHT}
    fps={FPS}
    durationInFrames={150}
    defaultProps={defaultProps as any}
    calculateMetadata={async ({ props }) => ({ durationInFrames: reelDurationFrames((props as unknown as ReelProps).clip) })}
  />
);
